export const WARRANTY_PORTFOLIOS = ['3_CP'];

export const EXCLUDED_FROM_WARRANTY = [
  '5_CP_COM_GEN',
  '5_CP_PLU_GEN',
  '5_CP_DLX_GEN',
  '5_CST_DKP_KP_G',
  '5_CST_DKP_KPH_G',
];
